import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { GenderItem } from 'components/page/Landing/constants'
import { CreateFilterValue } from 'components/page/Landing/LandingView/LandingFilter/CreateFilterValue'
import { SelectedFilter } from 'components/page/Landing/LandingView/LandingFilter/LandingSelectedFilter'
import { searchSettingsPath } from 'components/page/Search/Search.paths'
import { RouterLink } from 'components/presentational/link'
import { FilterSvg } from 'components/presentational/svg/FilterSvg'
import { StyledVisuallyHiddenText } from 'components/presentational/VisuallyHidden'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import {
  ThirdPartyPlace,
  useThirdPartyUrl,
} from 'hooks/temrorary/useThirdPartyUrl'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const LandingFilter: FC<{ genderList: GenderItem[] }> = ({
  genderList,
}) => {
  const { baseUrl } = useLayoutContext()
  const { pathname } = useLocation()

  const cleanPathname = baseUrl.replace(/\/girls|\/guys|\/gays|\/lesbians/g, '')

  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  // TODO костыль до исправления контекста в сео-лендинге
  const to = mergeAllUrls(baseUrl, searchSettingsPath).replace(
    '/search-setting/search-settings',
    '/search-settings'
  )

  const authorizationPath = useAuthorizationPath()
  const link = !authorized ? authorizationPath : to

  const thirdPartyUrl = useThirdPartyUrl(ThirdPartyPlace.filterIcon)

  const content = (
    <>
      <FilterSvg />
      <StyledVisuallyHiddenText>
        <FormattedMessage
          id="search.settings.name"
          defaultMessage="Настройки поиска"
        />
      </StyledVisuallyHiddenText>
    </>
  )

  return (
    <LandingFilterWrapper>
      <div data-name="geo-landing-gender-switch">
        <SelectedFilter
          href={cleanPathname}
          data-name="geo-landing-gender-select-all-action"
          isSelected={pathname === cleanPathname}
          id="geo-landing-gender-select-all-action"
        >
          <FormattedMessage id="app.all" defaultMessage="Все" />
        </SelectedFilter>
        {genderList.map((currentGender) => (
          <CreateFilterValue
            key={currentGender.id}
            cleanPathname={cleanPathname}
            currentGender={currentGender}
            pathname={pathname}
          />
        ))}
      </div>

      {thirdPartyUrl ? (
        <LandingFilterLink
          data-name="geo-landing-filter-link"
          to={thirdPartyUrl}
          isExternalLink={true}
        >
          {content}
        </LandingFilterLink>
      ) : (
        <LandingFilterLink data-name="geo-landing-filter-link" to={link}>
          {content}
        </LandingFilterLink>
      )}
    </LandingFilterWrapper>
  )
}

const LandingFilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const LandingFilterLink = styled(RouterLink)`
  text-decoration: none;
  cursor: pointer;

  svg {
    display: inline-block;
  }
`
